const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/die-cutter-machines`,
    saveSpeedTable: `${API_URL}/die-cutter-machine/save-speed-table`
};

export default apiUrls;
